<template>
  <div class="under-page-inner bg_color--1">
    <div v-if="NOTARIA" style="width: 100%; max-width: 800px;">
      <div v-if="!token">
        <v-icon size="80" class="mb-4">mdi-account-hard-hat</v-icon>
        <h1 class="text-h3 font-weight-bold mb-4">Página en construcción</h1>
        <p class="text-h6 mb-8 grey--text text--lighten-2">
          Estamos construyendo la nueva página web de <strong>{{NOTARIA.Nombre}}</strong>
        </p>
        
        <div class="mt-10">
          <p class="subtitle-1 mb-4">Acceda para ver los cambios</p>
          <Login />
        </div>
      </div>

      <div v-else class="text-center">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        <p class="mt-4 subtitle-1">Cargando sitio para administración...</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from '../store/index'
import { storeToRefs } from 'pinia'
const store = useStore();
const { NOTARIA, token } = storeToRefs(store)
definePageMeta({
  layout: 'blank'
})
</script>